import { useEffect, useRef } from 'react';
import { io, Socket } from 'socket.io-client';
import { useQueryClient } from '@tanstack/react-query';
import { API_CONFIG } from '../constants';
export function useBidSocket(bidId: string | undefined, enabled: boolean) {
  const queryClient = useQueryClient();
  const socketRef = useRef<Socket | null>(null);

  useEffect(() => {
    if (!bidId || !enabled) return;

    const socket = io(API_CONFIG.WS_URL, {
      transports: ['websocket'],
      reconnection: true,
    });
    socketRef.current = socket;

    socket.on('connect', () => {
      socket.emit('joinBid', bidId);
    });

    socket.on('bidUpdate', () => {
      queryClient.invalidateQueries({ queryKey: ['bid', bidId] });
      queryClient.invalidateQueries({ queryKey: ['bids'] });
    });

    return () => {
      socket.emit('leaveBid', bidId);
      socket.disconnect();
      socketRef.current = null;
    };
  }, [bidId, enabled, queryClient]);
}
